import { render } from "./PostModalSide.vue?vue&type=template&id=10d08a06"
import script from "./PostModalSide.vue?vue&type=script&lang=js"
export * from "./PostModalSide.vue?vue&type=script&lang=js"

import "./PostModalSide.vue?vue&type=style&index=0&id=10d08a06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__